module.exports = __webpack_public_path__ + "media/ThreePillarsPage_Music.a3b9519c.mp3";